import { IFormPage } from 'app/services/api5-service/api.interface';
import { map } from 'rxjs/operators';

import { getFontSize } from 'common/dynamic-form/utils/get-font-size';
import { isControlHaveBackground } from 'common/dynamic-form/utils/is-control-have-background';
import { prefix } from 'common/form-id-prefix/form-id-prefix.utils';
import { DocHelper } from 'utils/dochelper';

import { PageWrapperProps } from './model/page-props.interface';

import { ISPFieldConfig, ISPFormState } from '../../model';

/**
 * Check for presence of field with error on page from backend
 *
 * @param state
 * @param page
 */
function isPageContainError(state: ISPFormState, page: IFormPage): boolean {
  const fieldNameInError = state.docSubject.value.error?.$object;
  return (
    fieldNameInError !== undefined &&
    page.field?.some(f => f.$name === fieldNameInError)
  );
}

/**
 * Check if page should be opened
 *
 * @param state
 * @param page
 */
function isPageOpened(state: ISPFormState, page: IFormPage): boolean {
  const pageIsCollapsed = page.$collapsed !== 'yes';
  return isPageContainError(state, page) || pageIsCollapsed;
}

/**
 * Get props for page wrapper
 *
 * @param state
 * @param page
 * @returns
 */
export function getPageWrapperProps(
  state: ISPFormState,
  page: IFormPage,
): PageWrapperProps {
  const props: PageWrapperProps = {
    originalPage: page,
    pageTitle$: DocHelper.getMessage$(page.$name, state.docSubject).pipe(
      map(title => ({
        title,
        fontSize: getFontSize(page.$size),
      })),
    ),
    name: prefix(state.layoutService, page.$name),
    opened: isPageOpened(state, page),
    // @TODO i.ablov add streamable context
    collapseTooltipMsg: state.context.collapseTooltipMsg,
    expandTooltipMsg: state.context.expandTooltipMsg,
    collapsible: page.$collapsible !== 'no',
    displayBackground: page.$background === 'yes',
    displayHeaderBackground:
      page.$title_background !== 'no' &&
      isControlHaveBackground(state.docSubject.value),
    icon: page.$icon,
    inSprite: page.$spritesvg === 'yes',
  };

  return props;
}

/**
 * Append props, specific for page field wrapper
 *
 * @param config - config to append
 * @param state - dynamic form state
 * @param page - page metadata
 */
export function appendPageOptions(
  config: ISPFieldConfig,
  state: ISPFormState,
  page: IFormPage,
): void {
  const props = getPageWrapperProps(state, page);

  config.props = {
    ...props,
    ...config.props,
  };

  // @WARN page should set the location in the layout, depending on its metadata,
  // so this happens outside the scope of the get props function
  if (page.$type) {
    config.props.layoutPlace = page.$type;
  }
}
